import { gsap, Power2, Elastic } from "gsap";
import { memberPhotoUrl, memberForId } from "../api";
import { Cache } from "./Cache";
import IconTag from "../img/tag.png";
import IconLocation from "../img/location.png";

export const Members = function (isVertical, isLeft) {
    this.isActive = false;
    this.isVertical = isVertical;
    this.isLeft = isLeft;
    this.hideTimeline = null;
    this.showTimeline = null;

    const _maxRad = isVertical ? 80 : 100;
    const _multiplier = isVertical ? 0.08 : 0.1;
    const _rad = window.innerHeight * _multiplier > _maxRad ? _maxRad : parseInt(window.innerHeight * _multiplier);
    this.config = {
        radius: _rad,
        tagColor: "#605FB2",
        text: {
            plus: {
                lineHeight: parseInt((82 * _rad) / 100),
                font: `normal 800 ${parseInt((82 * _rad) / 100)}px Avenir`,
                colour: "#ffffff",
            },
            name: {
                lineHeight: parseInt((24 * _rad) / 100),
                font: `normal 800 ${parseInt((24 * _rad) / 100)}px Avenir`,
                colour: "#ffffff",
            },
        },
        hover: {
            range: 200,
            maxDist: 282,
        },
    };

    this.ctx = null;
    this.canvas = null;
    this.gallery = null;

    this.currentMoment = null;
    this.filter = {};
    this.tagTemplate = {
        x: 0,
        y: 0,
        scale: 1,
        opacity: 1,
        depth: 0,
        canClick: true,
        hoverOpacity: 0.2,
        width: this.config.radius * 2,
        height: this.config.radius * 2,
    };

    this.tags = [];
    this.selectedTags = [];
    this.deactivatedTags = [];

    this.updateCurrent = (_currentMoment) => {
        this.currentMoment = _currentMoment;
        this.tags = this.getTags(this.currentMoment);
    };

    this.init = (_Gallery, _currentMoment, _filter, _setFilter) => {
        Cache.add(IconTag);
        Cache.add(IconLocation);
        this.gallery = _Gallery;
        this.canvas = _Gallery.canvas;
        this.ctx = _Gallery.ctx;
        this.filter = _filter;
        this.setFilter = _setFilter;
        this.isSmallScreen = this.canvas.height < 2048;
    };

    // update moments data
    this.updateCurrentMoment = (moment) => {
        this.currentMoment = { ...moment };
        console.log("todo: update memebrs to new positions");
    };

    this.getLines = (ctx, text, maxWidth) => {
        const words = text.split(" ");
        const lines = [];
        let line = words[0];
        words.shift();

        if (words.length > 0) {
            words.map((word) => {
                const width = ctx.measureText(line + " " + word).width;
                if (width < maxWidth) {
                    line += " " + word;
                } else {
                    lines.push(line);
                    line = word;
                }
                return null;
            });
            lines.push(line);
        } else {
            lines.push(line);
        }

        return lines;
    };

    this.getAvailablePositions = (_moment) => {
        const increment = _moment.members.length > 8 ? 1.3 : 1.8;
        const positions = [];
        const { radius } = this.config;
        const expandedScale = this.isVertical ? 1.42 : 1.52;
        let pos = { x: _moment.width * expandedScale * -0.5, y: _moment.height * expandedScale * -0.5 + radius };

        // left side
        while (pos.y < _moment.height * expandedScale * 0.5 - radius * 3) {
            const _random = 1 + Math.random() * 0.075;
            positions.push({
                x: parseInt(pos.x * _random),
                y: parseInt(pos.y * _random),
            });
            pos.y += radius * increment;
            if (isVertical && isLeft) {
                // do not include if on left side of compare view
                if (pos.y > -180 && pos.y < 140) {
                    pos.y = 140;
                }
            }
        }

        // top side
        pos = { x: _moment.width * expandedScale * -0.5 + radius, y: _moment.height * expandedScale * -0.5 - radius * 0.5 };
        while (pos.x < _moment.width * expandedScale * 0.5 - radius * 2) {
            const _random = 1 + Math.random() * 0.075;
            positions.push({
                x: parseInt(pos.x * _random),
                y: parseInt(pos.y * _random),
            });
            pos.x += radius * increment;
            if (!this.isVertical && this.canvas.height < 1700) {
                // check to avoid filter overlap on small screens
                if (pos.x > -200 && pos.x < 280) {
                    pos.x = 280;
                }
            }
        }

        // right side
        pos = { x: _moment.width * expandedScale * 0.5, y: _moment.height * expandedScale * -0.5 + radius * 3 };
        while (pos.y < _moment.height * expandedScale * 0.5 - radius * 3) {
            const _random = 1 + Math.random() * 0.075;
            positions.push({
                x: parseInt(pos.x * _random),
                y: parseInt(pos.y * _random),
            });
            pos.y += radius * increment;
            if (isVertical && !isLeft) {
                // do not include if on right side of compare view
                if (pos.y > -180 && pos.y < 140) {
                    pos.y = 140;
                }
            }
        }
        // return position array.
        return positions;
    };

    this.getTags = (_moment) => {
        let positions = this.getAvailablePositions(_moment);

        const getRandomPos = () => {
            const index = Math.floor(Math.random() * positions.length);
            // If there are too many tags to fit around the moment, shoot them into space!
            if (!positions.length) positions.push({ x: -9999, y: -9999 });
            const position = positions[index];
            positions.splice(index, 1);
            return position;
        };

        // create location.
        const pos = getRandomPos();
        const location = {
            ...this.tagTemplate,
            x: pos.x,
            y: pos.y,
            offset: {
                x: 0,
                y: 0,
            },
            float: {
                x: 0,
                y: 0,
            },

            isLocation: true,
            name: _moment.location,
            inFilter: this.filter.location[0] === _moment.location,
            distance: 999,
            mouseOver: false,
            mouseLeave: false,
            timeline: null,
            hover: {
                labelOpacity: 1,
                labelY: 0,
                opacity: 0,
                plusOpacity: 0,
                plusY: 40,
            },
        };
        // create tags.
        const tags = _moment.tags
            .filter((_tag) => _tag.length > 0)
            .map((tag) => {
                const _pos = getRandomPos();
                return {
                    ...this.tagTemplate,
                    x: _pos.x,
                    y: _pos.y,
                    offset: {
                        x: 0,
                        y: 0,
                    },
                    float: {
                        x: 0,
                        y: 0,
                    },

                    isTag: true,
                    name: tag,
                    inFilter: this.filter.tags.find((_tag) => _tag === tag),
                    distance: 999,
                    mouseOver: false,
                    mouseLeave: false,
                    timeline: null,
                    hover: {
                        labelOpacity: 1,
                        labelY: 0,
                        opacity: 0,
                        plusOpacity: 0,
                        plusY: 40,
                    },
                };
            });
        // create members
        const members = _moment.members.map((id) => {
            const member = memberForId(id);
            Cache.add(memberPhotoUrl(member.photo));
            const _pos = getRandomPos();
            return {
                ...this.tagTemplate,
                x: _pos.x,
                y: _pos.y,
                offset: {
                    x: 0,
                    y: 0,
                },
                float: {
                    x: 0,
                    y: 0,
                },

                photo: memberPhotoUrl(member.photo),
                name: member.firstName,
                id: id,
                inFilter: this.filter.members.find((_id) => _id === id),
                distance: 999,
                mouseOver: false,
                mouseLeave: false,
                timeline: null,
                hover: {
                    labelOpacity: 1,
                    labelY: 0,
                    opacity: 0,
                    plusOpacity: 0,
                    plusY: 40,
                },
            };
        });

        return [location, ...tags, ...members];
    };

    this.selectTag = (tag) => {
        // check filter

        let isInFilter = false;
        if (tag.isLocation) {
            isInFilter = this.filter.location[0] === tag.name;
        } else if (tag.isTag) {
            isInFilter = this.filter.tags.find((_tag) => _tag === tag.name);
        } else if (tag.photo) {
            isInFilter = this.filter.members.find((_tag) => _tag === tag.id);
        }

        if (isInFilter) {
            const tl = new gsap.timeline();
            tl.to(tag.offset, { x: 15, duration: 0.05, ease: Power2.easeOut });
            tl.to(tag.offset, { x: -15, duration: 0.1, ease: Power2.easeInOut });
            tl.to(tag.offset, { x: 0, duration: 0.1, ease: Power2.easeInOut });
        } else {
            // get y of filter element
            // remove tag from tags array
            this.tags = this.tags.filter((_tag) => (tag.photo ? tag.id !== _tag.id : tag.name !== _tag.name));
            this.selectedTags = [tag];
            tag.canClick = false;
            let filterX = 0;
            let filterY = this.canvas.height * -0.5 + 230;
            if (isVertical) {
                filterX = this.isLeft ? this.canvas.width * -0.5 + 150 : this.canvas.width * 0.5 - 150;
                filterY = -30;
            }
            const tl = new gsap.timeline({
                onComplete: () => {
                    this.updateFilter(tag);
                },
            });
            tl.to(tag, { x: tag.x * 1.1, y: tag.y * 1.1, scale: 1.5, duration: 0.15, ease: Power2.easeOut })
                .to(tag, { x: filterX, y: filterY, duration: 0.4, ease: Power2.easeInOut })
                .to(tag, { scale: 0.2, duration: 0.4, ease: Power2.easeIn }, "-=0.4")
                .to(tag, { opacity: 0, duration: 0.1, ease: Power2.easeIn }, "-=0.1");
        }
    };

    this.updateFilter = (tag) => {
        this.selectedTags = [];
        this.hide();
        if (tag.isLocation) {
            this.setFilter({
                ...this.filter,
                location: [tag.name],
            });
        } else if (tag.isTag) {
            this.setFilter({
                ...this.filter,
                tags: [...this.filter.tags, tag.name],
            });
        } else if (tag.photo) {
            this.setFilter({
                ...this.filter,
                members: [...this.filter.members, tag.id],
            });
        }
    };

    this.show = (n) => {
        this.isActive = true;
        this.tags.map((tag) => {
            gsap.from(tag, { x: tag.x * 0.5, y: tag.y * 0.5, scale: 0, duration: 0.4, ease: Power2.easeOut, delay: Math.random() * 0.3 });
            return null;
        });
        return this.tags;
    };

    this.hide = (n) => {
        this.isActive = false;
        this.deactivatedTags = [...this.tags];
        this.tags.map((tag) => {
            gsap.killTweensOf(tag);
            return null;
        });

        this.tags = [];

        this.hideTimeline = new gsap.timeline();
        this.deactivatedTags.map((tag) => {
            this.hideTimeline.to(tag, { x: tag.x * 0.5, y: tag.y * 0.5, scale: 0, duration: 0.25, ease: Power2.easeIn }, 0);
            return null;
        });
    };

    this.onMagneticEnter = (tag) => {
        if (!tag.mouseOver) {
            tag.mouseOver = true;
        }
    };
    this.onMagneticLeave = (tag) => {
        if (tag.mouseOver) {
            tag.mouseOver = false;
            gsap.to(tag.offset, { x: 0, y: 0, duration: 1, ease: Elastic.easeOut });
            tag.distance = 999;
        }
    };
    this.onHover = (tag) => {
        if (!tag.isHover && !tag.inFilter) {
            tag.isHover = true;
            gsap.killTweensOf(tag.hover);
            gsap.to(tag.hover, { opacity: 0.2, labelY: -40, plusY: 0, labelOpacity: 0, plusOpacity: 1, duration: 0.2, ease: Power2.easeOut });
        }
    };
    this.onHoverEnd = (tag) => {
        if (tag.isHover) {
            tag.isHover = false;
            gsap.killTweensOf(tag.hover);
            gsap.to(tag.hover, { opacity: 0, labelY: 0, plusY: 40, labelOpacity: 1, plusOpacity: 0, duration: 0.2, ease: Power2.easeOut });
        }
    };

    // DRAW TAG / MEMBER / LOCATION ---------------z
    this.counter = 0;
    this.drawTag = (ctx, tag) => {
        this.counter++;
        const _x = tag.x + tag.offset.x + tag.float.x + this.canvas.width * 0.5;
        const _y = tag.y + tag.offset.y + tag.float.y + this.canvas.height * 0.5;
        const radius = this.config.radius * tag.scale;
        ctx.save();

        ctx.shadowBlur = 6;
        ctx.shadowOffsetY = 6;

        ctx.beginPath();
        this.ctx.translate(_x, _y);
        ctx.ellipse(0, 0, radius, radius, 0, 0, Math.PI * 2);
        ctx.closePath();
        ctx.fillStyle = this.config.tagColor;
        ctx.fill();

        ctx.shadowBlur = 0;
        ctx.shadowOffsetY = 0;
        // apply clipping path from elipse.
        ctx.clip();
        const photo = Cache.loaded[tag.photo];
        if (photo) {
            const ratio = photo.width / photo.height;
            const portrait = ratio < 1;

            ctx.drawImage(
                // Source image element
                photo,
                0,
                0,
                photo.width,
                photo.height,
                portrait ? -radius : -radius * ratio,
                portrait ? -radius / ratio : -radius,
                portrait ? radius * 2 : radius * 2 * ratio,
                portrait ? (radius * 2) / ratio : radius * 2
            );
        }

        // hover overlay
        ctx.fillStyle = `rgba(0,0,0,${tag.hoverOpacity + tag.hover.opacity})`;
        ctx.fillRect(-radius, -radius, radius * 2, radius * 2);

        let icon = null;
        if (tag.isLocation) {
            icon = Cache.loaded[IconLocation];
        }
        if (tag.isTag) {
            icon = Cache.loaded[IconTag];
        }

        ctx.globalAlpha = tag.hover.labelOpacity;
        const { config } = this;
        ctx.textAlign = "center";
        ctx.fillStyle = config.text.name.colour;
        ctx.font = config.text.name.font;
        const lineHeight = config.text.name.lineHeight;
        const lines = this.getLines(ctx, tag.name, config.radius * 2 - 40);
        lines.map((line, i) => {
            const yLine = lineHeight * 0.5 + i * lineHeight - (lines.length - 1) * (lineHeight * 0.5);
            if (tag.isLocation || tag.isTag) {
                ctx.fillText(line, 0, yLine + tag.hover.labelY + radius * 0.3, config.radius * 2);
            } else {
                ctx.fillText(line, 0, yLine + tag.hover.labelY, config.radius * 2);
            }
        });
        this.ctx.imageSmoothingEnabled = true;
        if (icon) {
            ctx.drawImage(
                // Source image element
                icon,
                0,
                0,
                icon.width,
                icon.height,
                -radius * 0.4,
                -radius * 0.4 - parseInt(lines.length * config.text.name.lineHeight * 0.5) - radius * 0.12 + tag.hover.labelY,
                radius * 0.8,
                radius * 0.8
            );
        }

        ctx.globalAlpha = tag.hover.plusOpacity;
        ctx.fillStyle = config.text.plus.colour;
        ctx.font = config.text.plus.font;
        ctx.fillText("+", 0, radius * 0.28 + tag.hover.plusY, config.radius * 2);

        ctx.restore();
        // TODO:
        // - Text
        // - Hover

        // ctx.restore();
    };

    this.update = (ctx) => {
        ctx.shadowColor = "rgba(0,0,0,0.2)";
        this.deactivatedTags.map((tag) => this.drawTag(ctx, tag));
        this.tags.map((tag) => this.drawTag(ctx, tag));
        this.selectedTags.map((tag) => this.drawTag(ctx, tag));
        ctx.shadowBlur = 0;
        ctx.shadowOffsetY = 0;
    };
};
